export default __webpack_public_path__ + "static/media/WinnerSound.7d93d0a7.wav";